import axios from "axios";
import Cookies from "js-cookie";

export const http = axios.create({
  baseURL: "/apis",
  timeout: 100000,
  headers: {
    "Content-Type": "application/json"
  },
  withCredentials: true
});

// 요청 인터셉터
http.interceptors.request.use(
  async (config) => {
    console.log(`▼▼▼ request : [ ${config.method} ] ${config.url} ▼▼▼`);
    config.headers["Authorization"] = Cookies.get("Authorization");
    config.headers["RefreshToken"] = Cookies.get("RefreshToken");
    console.log(config);
    return config;
  },
  (error) => {
    console.log(error);
    return Promise.reject(error);
  }
);

// 응답 인터셉터
http.interceptors.response.use(
  (response) => {
    console.log(
      `▽▽▽ response : [ ${response.config.method} ] ${response.config.url} ▽▽▽`
    );
    console.log(response);
    return response;
  },
  (error) => {
    console.error(error);
    return Promise.reject(error);
  }
);
